module.exports = __webpack_public_path__ + "static/img/25.868cf335.jpg";